<template>
  <div>
    <el-alert title="未启用时不会发信。测试发送失败会记到发送日志，密码留空表示不修改。" type="info" :closable="false" show-icon style="margin-bottom:12px" />
    <el-form :model="form" label-width="120px" style="max-width:640px" v-loading="loading">
      <el-form-item label="启用通知"><el-switch v-model="form.enabled" active-value="1" inactive-value="0" /></el-form-item>
      <el-form-item label="SMTP主机"><el-input v-model="form.smtpHost" placeholder="smtp.example.com" /></el-form-item>
      <el-form-item label="端口"><el-input-number v-model="form.smtpPort" :min="1" :max="65535" style="width:100%" /></el-form-item>
      <el-form-item label="账号"><el-input v-model="form.smtpUser" /></el-form-item>
      <el-form-item label="密码"><el-input v-model="form.smtpPassword" type="password" show-password placeholder="留空则不修改" /></el-form-item>
      <el-form-item label="发件人"><el-input v-model="form.mailFrom" placeholder="默认与账号相同" /></el-form-item>
      <el-form-item label="发件人名称"><el-input v-model="form.mailFromName" /></el-form-item>
      <el-form-item label="SSL"><el-switch v-model="form.useSsl" active-value="1" inactive-value="0" /></el-form-item>
      <el-form-item label="STARTTLS"><el-switch v-model="form.useTls" active-value="1" inactive-value="0" /></el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
        <el-button @click="testVisible = true">测试发送</el-button>
      </el-form-item>
    </el-form>
    <el-dialog title="测试发送" :visible.sync="testVisible" width="420px">
      <el-form label-width="80px">
        <el-form-item label="收件箱"><el-input v-model="testEmail" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="testVisible = false">取消</el-button>
        <el-button type="primary" :loading="testing" @click="doTest">发送</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getEmailConfig, saveEmailConfig, testEmailConfig } from '../../api/email'

function emptyForm() {
  return { enabled: '0', smtpHost: '', smtpPort: 465, smtpUser: '', smtpPassword: '', mailFrom: '', mailFromName: '', useSsl: '1', useTls: '0' }
}

export default {
  data() {
    return { loading: false, saving: false, testing: false, testVisible: false, testEmail: '', form: emptyForm() }
  },
  created() { this.load() },
  methods: {
    load() {
      this.loading = true
      getEmailConfig().then(res => {
        const cfg = res.data || {}
        this.form = Object.assign(emptyForm(), cfg, { smtpPassword: '' })
      }).finally(() => { this.loading = false })
    },
    save() {
      if (!this.form.smtpHost) { this.$message.warning('请填写SMTP主机'); return }
      this.saving = true
      saveEmailConfig(this.form).then(() => { this.$message.success('已保存'); this.load() }).finally(() => { this.saving = false })
    },
    doTest() {
      if (!this.testEmail) { this.$message.warning('请填写收件邮箱'); return }
      this.testing = true
      testEmailConfig(this.testEmail).then(() => {
        this.$message.success('测试邮件已发送')
        this.testVisible = false
      }).finally(() => { this.testing = false })
    }
  }
}
</script>
